export const productsLeadsIcons = [
  {
    arrow: "arrow_lightTurquoise_black",
    color: "turquoise",
  },
  {
    arrow: "arrow_lightPink_black",
    color: "red",
  },
  {
    arrow: "arrow_lightOrange_black",
    color: "orange",
  },
  {
    arrow: "arrow_gray_black",
    color: "blue",
  },
]
